import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminContratosPage } from "@/features/admin-contratos-anualizados/components/AdminContratosPage";
import { contratosAdminQueryOptions } from "@/features/admin-contratos-anualizados/hooks/use-contratos";

/**
 * Ruta `/admin/contratos-anualizados` · precarga la primera página (sin
 * filtro · debe coincidir con los params iniciales de AdminContratosPage).
 */
export const Route = createFileRoute("/_authed-tw/admin/contratos-anualizados/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(contratosAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminContratosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
